import React, { FC } from 'react';

import './App.css';
import { Box } from '@mui/material';
import { Home } from './Pages/Home';
import { Header } from './Components/Header';

export type AppProps = {

}
export const App: FC<AppProps> = () => {
  return (
    <Box>
      <Header />
      <Home />
    </Box>
  );
}

export default App;
